export default (link: string) => {
    try {
        const url = new URL(link);
        return url.pathname.replace(/-/gi, ' ').split('/')[1] || 'main';
    } catch (e) {
        throw new Error(e);
    }
};



// WEBPACK FOOTER //
// ./app/assets/javascripts/helpers/getPageNameFromUrl.ts